const Experience = () => {
    return (
        <div className="container-fluid main-content">
            <article className="about mt-4">
                <h1>Professional Biography</h1>
                <p className="lead">Tech Career</p>
                <table className="table">
                    <thead>
                        <tr>
                        <th scope="col">Years</th>
                        <th scope="col">Experiences</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">2022 - Present</th>
                            <td>
                                <span className="fw-bold">Senior Software Engineer (Full Stack)</span>
                                <span className="fst-italic">
                                    <br />National University of Singapore
                                </span>
                                <br />Lead technical design and development for cybersecurity R&amp;D and full-stack research platforms. Contribute scenario and challenge content for annual cybersecurity exercises and hackathons, develop ICS training materials for university penetration testing courses, and build full-stack web applications for health informatics and research platforms under the Singapore Data Science Consortium and SIA-NUS Aviation Corporate Laboratory (ReactJS, Python Flask, backend AI components).
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">2018 - 2022</th>
                            <td>
                                <span className="fw-bold">
                                    Software Engineer (Solution Consultant)
                                </span>
                                <span className="fst-italic">
                                    <br />Esri Singapore
                                </span>
                                <br />Led full-stack development of enterprise GIS applications for defense and port clients, applying security-by-design principles and robust access controls. Hired on the developer track and promoted twice for technical leadership. Engineered secure web and mobile applications (ReactJS, Node.js, C# .NET MVC) with data encryption, secure API authentication, and input validation. Conducted technical training on secure coding, vulnerability mitigation, and data privacy for internal teams and government clients.
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">2013 - 2018</th>
                            <td>
                                <span className="fw-bold">
                                    Software and Cloud Application Developer
                                </span>
                                <span className="fst-italic">
                                    <br />Various Startups
                                </span>
                                <br />Delivered secure, cloud-native full-stack web and mobile MVPs, including a fintech platform for AML &amp; KYC (Django, JavaScript, third-party APIs). Spearheaded ISO 27001 compliance and code repository protocols, mentoring junior developers and resolving critical vulnerabilities. Optimized cloud architecture with serverless solutions and data engineering (Redis, in-memory tables) to process millions of unstructured records.
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div className="my-2 text-center seperator">
                    &bull; &bull; &bull;
                </div>
                <p className="lead">Volunteer Career</p>
                <table className="table">
                    <thead>
                        <tr>
                        <th scope="col">Years</th>
                        <th scope="col">Activities</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">2018 - 2019</th>
                            <td>
                                <span className="fw-bold">Event Volunteer</span>
                                <span className="fst-italic">
                                    <br />OWASP Foundation, Singapore Chapter
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">2018</th>
                            <td>
                                <span className="fw-bold">Youth Chapter Volunteer</span>
                                <span className="fst-italic">
                                    <br />Singapore Computer Society
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">2016 - Present</th>
                            <td>
                                <span className="fw-bold">Volunteer Special Constable</span>
                                <span className="fst-italic">
                                    <br />Singapore Police Force
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">2013 - Present</th>
                            <td>
                                <span className="fw-bold">NS Company Sergeant Major</span>
                                <span className="fst-italic">
                                    <br />Singapore Armed Forces
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div className="my-2 text-center seperator">
                    &bull; &bull; &bull;
                </div>
            </article>
        </div>
    );
};

export default Experience;
